import React from 'react';
import DeleteMessage from './deleteMessage';
import moment from "moment";
import { MESSAGE_STATUS } from './../../../utile';

const TEACHER_ID = localStorage.getItem('discussion_uId');
class VideoView extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { conversation } = this.props;
        return (
            <div className={`ask-wr ${conversation.direction == 2 ? 'ma-right' : 'ma-left1'}`}>
                <video className="conversation-video" autoPlay={false} controls
                    controlsList="nodownload">
                    <source src={conversation.content} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div className="ma-clearFix"> </div>
                <span className={`message-time  ${conversation.direction == 2 ? '' : 'ma-right'}`}>{moment(conversation.createdAt).format('lll')} {conversation.direction == 2 && (conversation.status == MESSAGE_STATUS.sent ? <i className="pi pi-check sent-icon" /> : conversation.status == MESSAGE_STATUS.sending ? <i className="pi pi-spinner sent-icon" /> : ' ')}</span>
                {(conversation.direction == 2 && conversation.from._id == this.props.discussionUser._id) && <DeleteMessage conversation={conversation} deleteMessage={this.props.deleteMessage} />}
            </div>
        );
    }
}


export default VideoView;